import React from "react";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import AnimatedText from "react-animated-text-content";
import { useBreakpoint } from "gatsby-plugin-breakpoints";

import Button from "../Button";

import * as heroStyles from "./Hero.module.css";

const Hero = ({ props }) => {
  const {
    headline,
    subHeadline,
    heroCopy,
    backgroundImage,
    backgroundOverlay,
    contentHorizontalAlign,
    cta,
  } = props;

  const imageSrc = backgroundImage && getImage(backgroundImage);

  const breakpoints = useBreakpoint();

  return (
    <div
      className={`${heroStyles.hero}  ${heroStyles[contentHorizontalAlign]}`}
    >
      {backgroundImage && (
        <GatsbyImage
          image={imageSrc}
          alt={backgroundImage.description}
          className={heroStyles.backgroundImage}
          loading="eager"
        />
      )}
      {backgroundImage && backgroundOverlay && (
        <div
          className={`${heroStyles.backgroundOverlay} ${heroStyles[backgroundOverlay]}`}
        />
      )}
      <div
        className={`${heroStyles.content}`}
        // data-aos={breakpoints.md ? null : "fade-up"}
        // data-aos-offset={breakpoints.md ? null : "0"}
      >
        {breakpoints.md ? (
          <h1 className={heroStyles.headline}>{headline}</h1>
        ) : (
          <AnimatedText
            type="words"
            animationType="lights"
            interval={0.03}
            duration={0.25}
            tag="h1"
            includeWhiteSpaces
            threshold={0.1}
            rootMargin="90%"
            className={heroStyles.headline}
          >
            {headline}
          </AnimatedText>
        )}

        {subHeadline && (
          <h2 className={heroStyles.subHeadline}>{subHeadline}</h2>
        )}
        {heroCopy && <p>{heroCopy}</p>}
        {cta && (
          <div className={heroStyles.cta}>
            <Button destination={cta.to} styleAsButton={cta.styleAsButton}>
              {cta.title}
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};

export default Hero;
